import { DefaultLogger } from './default-logger'
import { fromString } from './log-level'

/**
 * Returns new instance of DefaultLogger, considering all logger relevant settings from process.env.
 * It's up to the caller to make sure the process.env is filled with logger relevant fields (for example, by using dotenv).
 */
export function createDefaultLogger(prefix: string = '') {
  // eslint-disable-next-line no-process-env
  const level = fromString(process.env['LOG_LEVEL'] || 'INFO')
  return new DefaultLogger({ level, usePrefix: prefix })
}
